import { TaskContext } from "contexts/TaskDetailContext";
import { useCallback, useContext, useEffect, useState } from "react";
import { getImages } from "services/models/modelDetails/modelTasks/images";
import TabelRowImage from "components/Elements/TabelRowImage";
import { ModelContext } from "contexts/ModelDetailContext";
import i18n from "i18n";

export default function useModelTaskImages({ taskInfo, getError, isMounted }) {
	const [openImage, setOPenImage] = useState(false);
	const [ImageToOpen, setImageToOpen] = useState(null);
	const [taskState, CtxDispatch] = useContext(TaskContext);
	const [state, MtxDispatch] = useContext(ModelContext);
	const [images, setImage] = useState({
		data: [],
		loading: true,
		open: false,
		imageId: null,
		delete: false,
		originalData: [],
		count: taskState?.taskInfo?.imageCount,
	});
	const setState = (da) => setImage((th) => ({ ...th, ...da }));
	const apiResponse = useCallback((x) => {
		return {
			...x,
			description: x.description === null ? "" : x.description,
			image: (
				<TabelRowImage
					imageURL={x?.thumbnailURL}
					imageHeight={"100px"}
					imageWidth={"100px"}
					onClickImage={() => {
						setOPenImage(true);
						setImageToOpen(x?.imageURL);
					}}
				/>
			),
		};
	}, []);
	const errorResponse = (result) => {
		if (result.data.detail) getError(result.data.detail);
		else getError(i18n.t("message.somethingWentWrongExclaim"));
	};

	const fetchTaskImages = async (showLoading = true) => {
		showLoading && setState({ loading: true });
		try {
			let result = await getImages(taskInfo.id);
			if (!isMounted.aborted) {
				showLoading && setState({ loading: false });
				if (result.status) {
					const responseData = result.data.map((x) => apiResponse(x));
					setState({ data: responseData, originalData: responseData });
					if (result.data.length > 0) {
						CtxDispatch({ type: "SET_IMAGES", payload: true });
					} else {
						CtxDispatch({ type: "SET_IMAGES", payload: false });
					}
				} else {
					errorResponse(result);
				}
			}
		} catch (e) {
			return;
		}
	};

	useEffect(() => {
		fetchTaskImages();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return {
		CtxDispatch,
		ImageToOpen,
		MtxDispatch,
		apiResponse,
		errorResponse,
		fetchTaskImages,
		images,
		openImage,
		setImage,
		setImageToOpen,
		setOPenImage,
		setState,
		state,
	};
}
